import h from "trader-hyperscript";
import { Source } from "trader.ts/types/source";
import { dyn, scheduleForCleanup } from "trader.ts/ui";

export function renderPopupModal(
  s: Source<boolean>,
  content: (opts: { close: () => void }) => HTMLElement,
  opts?: { className?: string },
): HTMLElement {
  const dia = (
    <dialog inert className={opts?.className || ""}>
      {dyn(s, (show) =>
        show === false ? <span></span> : content({ close: () => dia.close() }),
      )}
    </dialog>
  ) as HTMLElement & {
    showModal: () => void;
    close: () => void;
  };
  const currentShow = s.get();
  if (currentShow === true) {
    dia.removeAttribute("inert");
    dia.showModal();
  }
  dia.addEventListener("close", () => {
    s.set(false);
  });

  dia.addEventListener("click", function (event) {
    // Close when clicking on backdrop
    // https://stackoverflow.com/a/26984690
    const rect = dia.getBoundingClientRect();
    const isInDialog =
      rect.top <= event.clientY &&
      event.clientY <= rect.top + rect.height &&
      rect.left <= event.clientX &&
      event.clientX <= rect.left + rect.width;
    if (!isInDialog) {
      dia.close();
    }
  });
  scheduleForCleanup(
    s.observe((show) => {
      if (show === true) {
        dia.removeAttribute("inert");
        dia.showModal();
      } else {
        dia.setAttribute("inert", "true");
        dia.close();
      }
    }),
  );
  return dia;
}
